/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Interest_Blue_Chip_StocksInputs */

const en_onboarding_v1_interest_blue_chip_stocks = /** @type {(inputs: Onboarding_V1_Interest_Blue_Chip_StocksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blue Chip Stocks (Apple, Nvidia)`)
};

const de_onboarding_v1_interest_blue_chip_stocks = /** @type {(inputs: Onboarding_V1_Interest_Blue_Chip_StocksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blue-Chip-Aktien (Apple, Nvidia)`)
};

const pt_br2_onboarding_v1_interest_blue_chip_stocks = /** @type {(inputs: Onboarding_V1_Interest_Blue_Chip_StocksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ações blue chip (Apple, Nvidia)`)
};

const tr_onboarding_v1_interest_blue_chip_stocks = /** @type {(inputs: Onboarding_V1_Interest_Blue_Chip_StocksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blue chip hisseler (Apple, Nvidia)`)
};

const zh_cn2_onboarding_v1_interest_blue_chip_stocks = /** @type {(inputs: Onboarding_V1_Interest_Blue_Chip_StocksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`蓝筹股（Apple、Nvidia）`)
};

const zh_hk2_onboarding_v1_interest_blue_chip_stocks = /** @type {(inputs: Onboarding_V1_Interest_Blue_Chip_StocksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`藍籌股（Apple、Nvidia）`)
};

const ko_kr2_onboarding_v1_interest_blue_chip_stocks = /** @type {(inputs: Onboarding_V1_Interest_Blue_Chip_StocksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`우량주(Apple, Nvidia)`)
};

const ru_ru2_onboarding_v1_interest_blue_chip_stocks = /** @type {(inputs: Onboarding_V1_Interest_Blue_Chip_StocksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Акции крупных компаний (Apple, Nvidia)`)
};

const es_419_onboarding_v1_interest_blue_chip_stocks = /** @type {(inputs: Onboarding_V1_Interest_Blue_Chip_StocksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acciones de primera línea (Apple, Nvidia)`)
};

/**
* | output |
* | --- |
* | "Blue Chip Stocks (Apple, Nvidia)" |
*
* @param {Onboarding_V1_Interest_Blue_Chip_StocksInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_interest_blue_chip_stocks = /** @type {((inputs?: Onboarding_V1_Interest_Blue_Chip_StocksInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Interest_Blue_Chip_StocksInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_interest_blue_chip_stocks(inputs)
	if (locale === "de") return de_onboarding_v1_interest_blue_chip_stocks(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_interest_blue_chip_stocks(inputs)
	if (locale === "tr") return tr_onboarding_v1_interest_blue_chip_stocks(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_interest_blue_chip_stocks(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_interest_blue_chip_stocks(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_interest_blue_chip_stocks(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_interest_blue_chip_stocks(inputs)
	return es_419_onboarding_v1_interest_blue_chip_stocks(inputs)
});